module.exports = __webpack_public_path__ + "static/media/royal-caribbean-logo-white.a18d7349.svg";